import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSite } from '../../context/SiteContext';
import useNotifications from '../../hooks/useNotifications';
import './AdminLayout.css';
import { PasswordInput } from '../../components/common';

/* ─── Badge pastille ─── */
const Badge = ({ count }) => {
  if (!count || count <= 0) return null;
  return (
    <span style={{
      background: 'var(--brand-accent)', color: 'white',
      fontSize: 10, fontWeight: 800,
      padding: '1px 6px', borderRadius: 'var(--radius-full)',
      minWidth: 18, textAlign: 'center', lineHeight: '16px',
      display: 'inline-block', marginLeft: 'auto', flexShrink: 0,
    }}>
      {count > 99 ? '99+' : count}
    </span>
  );
};

/* ─── Icônes navigation (style Lucide) ─── */
const _s = (c) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{c}</svg>;
const NI = {
  dashboard:   _s(<><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>),
  briefcase:   _s(<><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>),
  orders:      _s(<><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/></>),
  fileText:    _s(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>),
  receipt:     _s(<><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1z"/><line x1="16" y1="8" x2="8" y2="8"/><line x1="16" y1="12" x2="8" y2="12"/><line x1="12" y1="16" x2="8" y2="16"/></>),
  creditCard:  _s(<><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></>),
  users:       _s(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>),
  monitor:     _s(<><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></>),
  signature:   _s(<><path d="M12 19l7-7 3 3-7 7-3-3z"/><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/><path d="M2 2l7.586 7.586"/><circle cx="11" cy="11" r="2"/></>),
  layers:      _s(<><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></>),
  package:     _s(<><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>),
  image:       _s(<><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></>),
  edit:        _s(<><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>),
  mail:        _s(<><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22 6 12 13 2 6"/></>),
  send:        _s(<><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>),
  message:     _s(<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>),
  help:        _s(<><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></>),
  settings:    _s(<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>),
  trending:    _s(<><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>),
  grid:        _s(<><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></>),
  sliders:     _s(<><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></>),
};

/* ─── Structure navigation avec sous-menus et badges ─── */
const buildNavGroups = (counts) => [
  {
    key: 'dashboard',
    items: [
      { to: '/admin', label: 'Tableau de bord', icon: NI.dashboard, exact: true },
    ]
  },
  {
    key: 'sales',
    label: 'Ventes',
    icon: NI.briefcase,
    badge: counts.quick_quotes_new,
    items: [
      { to: '/admin/orders',    label: 'Commandes',          icon: NI.orders,     badge: counts.quick_quotes_new },
      { to: '/admin/quotes',    label: 'Devis',              icon: NI.fileText },
      { to: '/admin/invoices',  label: 'Factures',           icon: NI.receipt },
      { to: '/admin/payments',  label: 'Règlements',         icon: NI.creditCard },
      { to: '/admin/clients',   label: 'Clients',            icon: NI.users },
      { to: '/admin/extranets', label: 'Extranets client',   icon: NI.monitor },
      { to: '/admin/signatures',label: 'Signatures',         icon: NI.signature },
      { to: '/admin/services',  label: 'Prestations',        icon: NI.briefcase },
    ]
  },
  {
    key: 'catalog',
    label: 'Catalogue',
    icon: NI.layers,
    roles: ['super_admin','admin'],
    items: [
      { to: '/admin/products', label: 'Produits & Catégories', icon: NI.package, roles: ['super_admin','admin'] },
      { to: '/admin/mockups',  label: 'Maquettes',             icon: NI.image,   roles: ['super_admin','admin'] },
    ]
  },
  {
    key: 'content',
    label: 'Contenu',
    icon: NI.edit,
    badge: counts.messages_unread,
    items: [
      { to: '/admin/blog',       label: 'Blog',               icon: NI.edit },
      { to: '/admin/newsletter', label: 'Newsletter',         icon: NI.mail },
      { to: '/admin/emails',     label: 'Emails & Templates', icon: NI.send },
      { to: '/admin/messages',   label: 'Messages',           icon: NI.message, badge: counts.messages_unread },
      { to: '/admin/faq',        label: 'FAQ',                icon: NI.help },
    ]
  },
  {
    key: 'admin',
    label: 'Administration',
    icon: NI.settings,
    roles: ['super_admin','admin'],
    items: [
      { to: '/admin/reports',  label: 'Rapports',     icon: NI.trending, roles: ['super_admin','admin','support'] },
      { to: '/admin/media',    label: 'Médiathèque',  icon: NI.grid,     roles: ['super_admin','admin','collaborator'] },
      { to: '/admin/settings', label: 'Paramètres',   icon: NI.sliders,  roles: ['super_admin','admin'] },
    ]
  },
];

const NavGroup = ({ group, user, collapsed, isOpen, onToggle }) => {
  const location = useLocation();

  const isGroupActive = group.items.some(item =>
    item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to)
  );

  if (group.roles && !group.roles.includes(user?.role)) return null;

  const visibleItems = group.items.filter(item =>
    !item.roles || item.roles.includes(user?.role)
  );
  if (!visibleItems.length) return null;

  // Groupe sans label = items directs
  if (!group.label) {
    return (
      <>
        {visibleItems.map(item => (
          <NavLink key={item.to} to={item.to} end={item.exact}
            className={({ isActive }) => `sidebar-nav-link${isActive ? ' active' : ''}`}
            title={collapsed ? item.label : ''}>
            <span className="nav-icon">{item.icon}</span>
            {!collapsed && <span className="nav-label">{item.label}</span>}
            {!collapsed && <Badge count={item.badge} />}
          </NavLink>
        ))}
        <div className="nav-separator" />
      </>
    );
  }

  if (collapsed) {
    return (
      <>
        {visibleItems.map(item => (
          <NavLink key={item.to} to={item.to}
            className={({ isActive }) => `sidebar-nav-link${isActive ? ' active' : ''}`}
            title={item.label} style={{ position: 'relative' }}>
            <span className="nav-icon">{item.icon}</span>
            {item.badge > 0 && (
              <span style={{ position: 'absolute', top: 4, right: 4, width: 8, height: 8, borderRadius: '50%', background: 'var(--brand-accent)', border: '2px solid var(--sidebar-bg)' }} />
            )}
          </NavLink>
        ))}
        <div className="nav-separator" />
      </>
    );
  }

  return (
    <div className={`nav-group${isOpen ? ' open' : ''}${isGroupActive ? ' group-active' : ''}`}>
      <button className="nav-group-header" onClick={onToggle}>
        <div className="nav-group-left">
          <span className="nav-icon">{group.icon}</span>
          <span className="nav-group-label">{group.label}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {group.badge > 0 && !isOpen && <Badge count={group.badge} />}
          <svg className="nav-group-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </div>
      </button>

      <div className="nav-group-items">
        {visibleItems.map(item => (
          <NavLink key={item.to} to={item.to}
            className={({ isActive }) => `sidebar-nav-link sidebar-nav-sub${isActive ? ' active' : ''}`}>
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
            <Badge count={item.badge} />
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export const AdminLayout = () => {
  const { user, logout }  = useAuth();
  const { settings }      = useSite();
  const navigate          = useNavigate();
  const location          = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const { counts }        = useNotifications();
  const prevCountsRef     = React.useRef(counts);

  const navGroups = buildNavGroups(counts);

  // Détermine quel groupe contient la route active
  const activeGroupKey = navGroups.find(g =>
    g.label && g.items.some(item =>
      item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to)
    )
  )?.key ?? null;

  const [openGroup, setOpenGroup] = useState(activeGroupKey);

  // Quand la route change (navigation directe), ouvre le bon groupe
  React.useEffect(() => {
    if (activeGroupKey) setOpenGroup(activeGroupKey);
  }, [activeGroupKey]);

  const toggleGroup = (key) => setOpenGroup(prev => prev === key ? null : key);

  // Popup pour nouvelles demandes
  React.useEffect(() => {
    const prev = prevCountsRef.current;
    if (prev.orders_new !== undefined) {
      // Nouvelles commandes studio
      const newOrders = (counts.orders_new || 0) - (prev.orders_new || 0);
      if (newOrders > 0) {
        toast.info(`🎨 ${newOrders} nouvelle${newOrders > 1 ? 's' : ''} demande${newOrders > 1 ? 's' : ''} studio`, {
          position: 'bottom-right',
          autoClose: 8000,
          onClick: () => navigate('/admin/orders'),
          style: { cursor: 'pointer' },
        });
      }
      // Nouveaux devis rapides
      const newQQ = (counts.quick_quotes_new || 0) - (prev.quick_quotes_new || 0);
      if (newQQ > 0) {
        toast.info(`📋 ${newQQ} nouveau${newQQ > 1 ? 'x' : ''} devis rapide${newQQ > 1 ? 's' : ''}`, {
          position: 'bottom-right',
          autoClose: 8000,
          onClick: () => navigate('/admin/orders'),
          style: { cursor: 'pointer' },
        });
      }
    }
    prevCountsRef.current = counts;
  }, [counts, navigate]);

  const handleLogout = () => { logout(); navigate('/admin/login'); };

  const roleLabels = {
    super_admin: 'Super Admin', admin: 'Admin',
    collaborator: 'Collaborateur', support: 'Support'
  };

  return (
    <div className={`admin-layout${collapsed ? ' sidebar-collapsed' : ''}`}>
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            {(settings.site_logo_admin || settings.site_logo)
              ? <img src={settings.site_logo_admin || settings.site_logo} alt="Logo" style={{ width: collapsed ? 32 : 36, height: collapsed ? 32 : 36, objectFit: 'contain', borderRadius: 4 }} />
              : <span className="logo-mark">{(settings.site_name || 'P')[0].toUpperCase()}</span>
            }
            {!collapsed && <span className="logo-name">{settings.site_name || 'Artimarq'}</span>}
          </div>
          <button className="sidebar-toggle" onClick={() => setCollapsed(!collapsed)} aria-label="Toggle sidebar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {collapsed
                ? <><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></>
                : <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>
              }
            </svg>
          </button>
        </div>

        <nav className="sidebar-nav">
          {navGroups.map(group => (
            <NavGroup key={group.key} group={group} user={user} collapsed={collapsed}
              isOpen={openGroup === group.key}
              onToggle={() => toggleGroup(group.key)}
            />
          ))}
        </nav>

        <div className="sidebar-footer">
          {!collapsed && (
            <div className="user-info">
              <div className="user-avatar">{user?.first_name?.[0]}{user?.last_name?.[0]}</div>
              <div className="user-details">
                <div className="user-name">{user?.first_name} {user?.last_name}</div>
                <div className="user-role">{roleLabels[user?.role] || user?.role}</div>
              </div>
            </div>
          )}
          <div style={{ display: 'flex', gap: 6, flexDirection: collapsed ? 'column' : 'row' }}>
            <a href="/" target="_blank" rel="noreferrer" className="footer-action-btn" title="Voir le site">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
                <polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
              </svg>
            </a>
            <button onClick={handleLogout} className="footer-action-btn logout-btn" title="Déconnexion">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
                <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
            </button>
          </div>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

/* ── Login page ── */
export const AdminLoginPage = () => {
  const { login }    = useAuth();
  const { settings } = useSite();
  const navigate     = useNavigate();
  const [form, setForm]       = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try { await login(form.email, form.password); navigate('/admin'); }
    catch (err) { setError(err.response?.data?.message || 'Identifiants invalides'); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          {(settings.site_logo_admin || settings.site_logo)
            ? <img src={settings.site_logo_admin || settings.site_logo} alt="Logo" style={{ width: 48, height: 48, objectFit: 'contain', borderRadius: 6 }} />
            : <span className="logo-mark" style={{ width: 48, height: 48, fontSize: 24 }}>{(settings.site_name || 'P')[0].toUpperCase()}</span>
          }
          <h1 className="login-title">{settings.site_name || 'Artimarq'}</h1>
          <p className="login-subtitle">Espace d'administration</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="login-error">{error}</div>}
          <div className="form-field">
            <label className="form-label">Email</label>
            <input type="email" required className="form-input" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} placeholder="admin@artimarq.fr" autoComplete="email" />
          </div>
          <div className="form-field">
            <label className="form-label">Mot de passe</label>
            <PasswordInput required value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} autoComplete="current-password" />
          </div>
          <button type="submit" className={`btn btn-primary btn-lg btn-full${loading ? ' btn-loading' : ''}`} disabled={loading}>
            {loading ? <span className="btn-spinner" /> : null}
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 'var(--space-md)', fontSize: 13, color: 'var(--text-muted)' }}>
          <a href="/" style={{ color: 'var(--brand-accent)' }}>← Retour au site</a>
        </p>
      </div>
    </div>
  );
};

export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!loading && !user) navigate('/admin/login');
    if (!loading && user && roles && !roles.includes(user.role)) navigate('/admin');
  }, [user, loading, navigate, roles]);

  if (loading) return <div className="page-loader"><div className="spinner spinner-lg" /></div>;
  if (!user) return null;
  return children;
};